import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	content: {
		padding: '24px 16px'
	},
	header: {
		padding: '20px',
		'& h2': {
			margin: '0 10px 0 0',
			color: '#1A1A35',
			fontSize: '22px'
		}
	}
}))

const FacilitiesDashboard = () => {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<div className={classes.content}>Select a Facility</div>
		</div>
	)
}

export default FacilitiesDashboard
